// extracted by mini-css-extract-plugin
export default {"rootContainer":"ChatContainer__rootContainer___Hm0La"};